module.exports = __webpack_public_path__ + "img/delete.72ddc2f0.svg";